<template>
  <div class="outer-wrapper">
    <div class="tab-wrapper" v-show="detailShow==='index'">
      <van-tabs v-model="active" scrollspy sticky>
        <van-tab title="本年度">
          <div class="section-wrapper">
            <div class="title-wrapper">
              <p>
                <span style="color:#997562;" class="icon-down">
                  <van-icon name="coupon" />
                </span>
                统计一览(万元)
              </p>
            </div>
            <railway-data @clickMark="goTab"></railway-data>
          </div>
          <div class="section-wrapper">
            <div class="title-wrapper">
              <p>
                <span style="color:#997562;" class="icon-down">
                  <van-icon name="coupon" />
                </span>
                客户排行(万元)
              </p>
            </div>
            <div class="sub-section">
              <customer-data></customer-data>
            </div>
            <van-divider />
            <div class="sub-section">
              <customer-data :info="customerNotPayed"></customer-data>
            </div>
          </div>
        </van-tab>
        <van-tab title="上年度">
          <div class="section-wrapper">
            <div class="title-wrapper">
              <p>
                <span style="color:#997562;" class="icon-down">
                  <van-icon name="coupon" />
                </span>
                统计一览(万元)
              </p>
            </div>
            <railway-data :timeRange="1"></railway-data>
          </div>
        </van-tab>
      </van-tabs>
    </div>

    <div class="editor-wrapper" v-show="detailShow==='notpayedQuantity'">
      <van-nav-bar
        :title="'未付款订单一览'"
        left-text="返回"
        left-arrow
        @click-left="onClickBack('index')"
        fixed
      ></van-nav-bar>
      <van-search placeholder="请输入搜索关键词" v-model="keyword" @search="onSearch" />
      <!--<van-list
        v-model="itemTable.loading"
        :finished="itemTable.finished"
        finished-text="没有更多了"
        :error.sync="itemTable.error"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
      >
        <van-cell
          v-for="item in itemTable.tivdata"
          :key="item.id+'verify'"
          :title="item.standard_prefix+' '+item.standard_no+'-'+item.standard_year"
          :label="'《'+item.standard_name_ch+'》'"
          label-class="cell-label"
          @click="chooseItem(item)"
          is-link
        >
          <template>
            <van-tag plain type="success" v-if="item.if_controlled==='受控'" class="c-tag">受控</van-tag>
            <van-tag
              round
              :type="calStatCertificate(item.cma)"
              v-if="item.cma&&item.cma!=='未认证'"
              class="c-tag"
            >CMA</van-tag>
            <van-tag
              round
              :type="calStatCertificate(item.cnas)"
              v-if="item.cnas&&item.cnas!=='未认证'"
              class="c-tag"
            >CNAS</van-tag>
            <span :class="calStat(item.ifValid)">{{item.ifValid}}</span>
          </template>
        </van-cell>
      </van-list>-->
    </div>
  </div>
</template>
<script>
import railwayData from "./Base/RailwayData.vue";
import customerData from "./Base/CustomerData.vue";
let userToken = localStorage.getItem("current_user_token");
let authData = JSON.parse(localStorage.getItem("authData"));

function itemTableFac() {
  return {
    loading: false,
    finished: false,
    error: false,
    Tpage: {
      currentPage: 1,
      currentSize: 20
    },
    no_data_text: "",
    totalItems: 0,
    tivdata: [
      /*{
                        standard_prefix:'',
                        standard_no:"",
                        standard_year:'',
                        standard_name_ch:'',
                        file_url:'',
                        nation:'',
                        ifValid:'',
                    }*/
    ]
  };
}

export default {
  name: "railway",
  props: [],
  components: {
    railwayData,
    customerData
  },
  data() {
    return {
      askData: "railwayList",
      active: 0,
      itemTable: itemTableFac(),
      detailShow: 'index',
      currentItem: {},
      keyword: "",
      customerNotPayed:{
        title:'应收款总金额前十',
        limit:10,
        name:'notPayed',
        sale:'E',
        askData:'railwayCustomer'
      }
    };
  },
  methods: {
    linkTo(url) {
      window.open(this.$fileUrlFac(url, authData.sfileRight));
    },
    goTab(value){
      this.detailShow = value;
    },
    calStat(stat) {
      if (stat === "现行") {
        return "c-green";
      } else if (stat === "已废止") {
        return "c-red";
      } else if (stat === "未实施") {
        return "c-blue";
      } else {
        return "c-no";
      }
    },
    calStatCertificate(c) {
      if (c === "已认证") {
        return "success";
      } else if (c === "部分认证") {
        return "primary";
      } else {
        return "";
      }
    },
    onSearch() {
      this.itemTable = itemTableFac();
      this.onLoad();
    },
    onLoad() {
      this.itemTable.loading = true;
      this.$axios
        .post(this.$url + "/ask_list_data", {
          page: this.itemTable.Tpage,
          userToken: userToken,
          ask_data: "standardList",
          selected_list: [],
          keyword: this.keyword
        })
        .then(response => {
          for (let ele of response.data.res_record) {
            this.itemTable.tivdata.push(ele);
          }
          if (
            response.data.res_record.length < this.itemTable.Tpage.currentSize
          ) {
            this.itemTable.finished = true;
          }
          this.itemTable.loading = false;
          this.itemTable.Tpage.currentPage++;
        });
    },
    chooseItem(val) {
      this.currentItem = val;
      this.detailShow = true;
    },
    onClickBack(value) {
      this.detailShow = value;
    }
  }
};
</script>
<style scoped>
.inner-wrapper {
  width: 100%;
  background: #f7f7f7;
  min-height: 20rem;
}

.section-wrapper {
  background-color: #fff;
  padding-top: 0.8rem;
}

.title-wrapper {
  padding: 0.9rem 0.8rem;
  font-size: 0.7rem;
  font-weight: 600;
}

.icon-down {
  position: relative;
  top: 0.06rem;
}
</style>